import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Badge, Modal, Form } from "react-bootstrap";
import { pdf } from '@react-pdf/renderer';
import { saveAs } from "file-saver";

import "./ConciliationResultPage.scss"
import messages from "../../assets/i18n";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import StepProgressBar from "../../components/StepProgressBar/StepProgressBar";
import ConciliationResultTable from "../../components/ConciliationResultTable/ConciliationResultTable";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import ConciliationSeal from "../../components/ConciliationSeal/ConciliationSeal"
import ConciliationHistoryResultModal from "../../components/ConciliationHistoryResultModal/ConciliationHistoryResultModal"
import { HeaderActions, FooterActions, ToastMessage } from '../../components'
import { ALGODAO_BCI, DEMAIS_ATRIBUTOS_SUSTENTAVEIS } from '../../utils/constants';
import havePermission from '../../utils/havePermission'

class ConciliationResultPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			statusConciliacaoComercial: '',
			buttonLoading: false,
			showSustainabilityButton: false,
			modalShowHistory: false,
			motivoCancelamento: '',
			textoModalObservacao: ''
		};
	}

	setModalShowHistory = (showHistory) => {
		this.setState({ modalShowHistory: showHistory });
	}

	setModalObservacao = (showModal) => {
		this.props.dispatchModalObservacao(showModal);
	}

	setModalConfirmCancel = (showCancelModal) => {
		this.props.dispatchShowCancelModal(showCancelModal);
	}

	pageBack = () => {
		this.props.dispatchResetConciliation();
		if (this.props.fileStep && (this.props.taxConciliation === "" || this.props.taxConciliation === false) ) {
			this.props.history.push(`/reconcile`);
		} else {
			this.props.history.push(`/main`);
		}
	};

	cancelarConciliacao = () => {		
		this.setState({ buttonLoading: true });

		const order = this.props.orderList[0] ? this.props.orderList[0] : [];

		this.props.dispatchCancelConciliation(order, this.state.motivoCancelamento)
	}

	alterarObservacao = () => {		
		this.setState({ buttonLoading: true });

		const order = this.props.orderList[0] ? this.props.orderList[0] : [];

		this.props.dispatchAlterarObservacao(order, this.state.textoModalObservacao)
	}


	printSeal = (conciliationId) => {
		this.setState({ buttonLoading: true });

		this.props.dispatchConciliationSeal(conciliationId)
	}

	componentDidMount() {
		const order = this.props.orderList[0] ? this.props.orderList[0] : [];

		if (this.props.tradeConciliation !== '' || this.props.resultStep) {			
			this.props.dispatchConciliationResult(order)
			this.props.dispatchConciliationHistory(order)
		}

		if (order.empresa.exigirCertSustentabilidade && order.sustentabilidade && (order.sustentabilidade === ALGODAO_BCI || (order.sustentabilidade === DEMAIS_ATRIBUTOS_SUSTENTAVEIS))) {
			this.setState({ showSustainabilityButton: true });
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props !== prevProps) {
			const order = this.props.orderList[0] ? this.props.orderList[0] : [];
			if (this.props.tradeConciliation !== prevProps.tradeConciliation && this.props.tradeConciliation === false) {
				this.props.dispatchConciliationResult(order)
				this.props.dispatchConciliationHistory(order)
			}

			if (this.props.taxConciliation !== prevProps.taxConciliation && this.props.tradeConciliation !== '') {
				this.props.dispatchConciliationResult(order)
				this.props.dispatchConciliationHistory(order)
			}

			if (this.props.conciliationSeal !== prevProps.conciliationSeal && Object.keys(this.props.conciliationSeal).length >=0 ) {
				pdf(<ConciliationSeal  data={this.props.conciliationSeal} />).toBlob().then(blob => {
					saveAs(blob, "Selo da Conciliacao.pdf");
				});
				this.setState({ buttonLoading: false })
			}

			if (this.props.conciliationResult.reloadConciliationResultPage) {
				this.setState({ buttonLoading: false });
				this.props.dispatchSetPageReload(false);
				this.props.dispatchConciliationResult(order)
				this.props.dispatchConciliationHistory(order)
			}
		}
	}

	enableConciliationConditional = (statusComercial, statusFiscal) => 
		statusComercial && statusFiscal && (statusComercial.id === '2' && statusFiscal.id === '4');

    enableCheckConciliation = (statusComercial, statusFiscal) =>
        statusComercial && statusFiscal && (statusFiscal.id === '6');

	statusConciliacao = (status) => {
        return status && status.id && status.id === "2" ? "success" : status.id === "6" ? "waiting" : "danger";
	}

	buttonsConciliationConditional = (result, permissions, lang, isLoading, isLoadingInvoice, order) => {
		return <>
			{result && !(havePermission('btn-conciliate-conditional', permissions) &&
			 this.enableConciliationConditional(result.statusConciliacaoComercial, result.statusConciliacaoFiscal))
				? null
				: <>
					<ButtonStandard 
						id="reconcile_reconcile_button"
						text={messages[lang].conditionalCondicional}
						textClass="text-2"
						isLoading={isLoading}
						className="btn btn-primary btn-save btn-light"
						onClick={() => this.props.dispatchConciliationConditional(result.id, order)}
					/>
			</>}
		</>
	}

    buttonsCheckConciliation = (result, permissions, lang, isLoading, isLoadingInvoice, order) => {
        console.log(this.enableCheckConciliation(result.statusConciliacaoComercial, result.statusConciliacaoFiscal));
        return <>
            {
                this.enableCheckConciliation(result.statusConciliacaoComercial, result.statusConciliacaoFiscal)
                ? <>
                        <ButtonStandard
                            id="check_conciliation_status"
                            text={messages[lang].checkConciliationStatus}
                            textClass="text-2"
                            isLoading={isLoading}
                            className="btn btn-primary btn-save btn-light"
                            onClick={() => this.props.dispatchCheckConciliationStatus(result.id, order)}
                        />
                    </>
                : null }
        </>
    }

	buttonGroupRight = () => () => {
		const { permissions } = this.props
		const { lang } = this.props
		const { result, isLoadingInvoice } = this.props.conciliationResult
		const order = this.props.orderList[0] ? this.props.orderList[0] : [];
		const disabledButton = result 
				&& result.statusConciliacaoComercial && result.statusConciliacaoFiscal 
				? result.statusConciliacaoComercial.id && result.statusConciliacaoFiscal.id
				: false;

		return <>
			{
			havePermission('cancel-conciliation', permissions)
				?
					this.buttonCancelar(false)
				:
					null
			}
			{
			 this.buttonDownloadXmlNota(messages, lang, isLoadingInvoice, result, order)
			}
			{
			 this.buttonImprimir(disabledButton)
			}
		</>
	}

	buttonGroupLeft = () => () => {
		const { permissions } = this.props
		const { result, isLoading, isLoadingInvoice } = this.props.conciliationResult
		const order = this.props.orderList[0] ? this.props.orderList[0] : [];
		const { lang } = this.props;
		return <>
			{
			 this.buttonsConciliationConditional(result, permissions, lang, isLoading, isLoadingInvoice, order) 
			}
            {
                this.buttonsCheckConciliation(result, permissions, lang, isLoading, isLoadingInvoice, order)
            }
			{
				this.state.showSustainabilityButton && order.naturezaPedido !== "Amostra"
				?
					<ButtonStandard
						id="reconcile_reconcile_button"
						text={messages[lang].sustainability}
						textClass="text-2"
						isLoading={isLoading}
						className="btn btn-primary btn-save btn-light"
						onClick={() => this.props.history.push({
							pathname: '/sustainability',
							from: '/conciliation-status',
						})}
					/>
				:
				null
			}
			
			{
				order.fornecedor.exigirDeclProdutor && order.empresa.exigirDeclProdutor && order.naturezaPedido !== "Amostra"
				?
					<ButtonStandard
						id="reconcile_reconcile_button"
						text={messages[lang].producerDeclaration}
						textClass="text-2"
						isLoading={isLoading}
						className="btn btn-primary btn-save btn-light"
						onClick={() => this.props.history.push({
							pathname: '/producer-declaration',
							from: '/conciliation-status',
						})}
					/>
				:
				null
			}

		</>
	}

	buttonCancelar = (disabledButton) => <ButtonStandard
		id="reconcile_cancel_button"
		text={messages[this.props.lang].cancelConciliation}
		textClass="text-2"
		disabled={disabledButton}
		isLoading={this.state.buttonLoading}
		className="btn btn-primary btn-save btn-light"
		onClick={() => this.setModalConfirmCancel(true)}
	/>

	buttonImprimir = (disabledButton) => <ButtonStandard
			id="reconcile_reconcile_button"
			text={messages[this.props.lang].print}
			textClass="text-2"
			disabled={parseInt(disabledButton) !== 2}
			isLoading={this.state.buttonLoading}
			className="btn btn-primary btn-save btn-light"
			onClick={() => this.printSeal(this.props.conciliationResult.result.id)}
		/>

	buttonDownloadXmlNota = (messages, lang, isLoadingInvoice, result, order) => <ButtonStandard 
			id="reconcile_reconcile_button"
			text={messages[lang].downloadInvoice}
			textClass="text-2"
			isLoading={isLoadingInvoice}
			className="btn btn-primary btn-save btn-light"
			onClick={() => this.props.dispatchDownloadInvoice(result.id, order)}
		/>

	render() {

		const { lang } = this.props;
		const { result, isLoading, conciliationHistory, getToast, modalConfirmCancel, modalObservacao, modalMotivoReprovacao } = this.props.conciliationResult;
		const isEmpty = Object.keys(result).length === 0;
		return (
			<div className="conciliation-result-page">
				<ToastMessage 
					show={getToast.showToast} 
					setShow={this.props.dispatchHideToast}
					message={getToast.message} 
					toastClass={getToast.messageType} />

				<HeaderActions pageBack={this.pageBack} titlePage={messages[lang].conciliationInvoice} />
				{
				this.props.fileStep &&
					<Container className="my-5">
						<Row className="justify-content-center">
							<Col xl={10}>
								<StepProgressBar
									firstStep={this.props.fileStep}
									secondStep={this.props.tradeConciliation}
									thirtyStep={this.props.taxConciliation.status}
								/>
							</Col>
						</Row>
					</Container>
				}
				{
					isLoading ?
        	<Container className="mt-2 pt-3">
						<Row className="justify-content-center mt-5">
							<LoadingSpinner />
						</Row>
					</Container>
					:
						result &&
						result.pedido &&
						<Container className="mt-2 pt-3 mb-5 pb-5">
							<Container className="mt-2 pt-3">
								<Row className="conciliation-data">
									<Col xs={3} className="px-4">
										<Col className="rounded-top bg-color-primary py-2">
											<span className="text-2">{messages[lang].conciliationNumber}</span>
										</Col>
										<Col className="rounded-bottom bg-color-secondary py-2 mt-2">
											<span className="text-2">{result.id}</span>
										</Col>
									</Col>
									<Col xs={3} className="px-4">
										<Col className="rounded-top bg-color-primary py-2">
											<span className="text-2">{messages[lang].providerName}</span>
										</Col>
										<Col className="rounded-bottom bg-color-secondary py-2 mt-2">
											<span className="text-2">{result.pedido.fornecedor.nome}</span>
										</Col>
									</Col>
									<Col xs={3} className="px-4">
										<Col className="rounded-top bg-color-primary py-2">
											<span className="text-2">{messages[lang].Order}</span>
										</Col>
										<Col className="rounded-bottom bg-color-secondary py-2 mt-2">
											<span className="text-2">{result.pedido.id}</span>
										</Col>
									</Col>
									<Col xs={3} className="px-4">
										<Col className="rounded-top bg-color-primary py-2">
											<span className="text-2">{messages[lang].invoiceNumber}</span>
										</Col>
										<Col className="rounded-bottom bg-color-secondary py-2 mt-2">
											<span className="text-2">{result.notaFiscal}</span>
										</Col>
									</Col>
								</Row>
							</Container>
							<Container className="mt-5">
								<ConciliationResultTable itens={result.conciliacaoItems} />
							</Container>

							<Container className="my-4">
								<Row className="conciliations-result">
									<Col xs={6} className="pr-3 pl-4">
										<Col className="rounded-top bg-color-primary py-2">
											<span className="text-2">{messages[lang].statusCommercial}</span>
										</Col>
										<Col className="rounded-bottom py-2 border-primary">
											<Badge pill variant={this.statusConciliacao(result.statusConciliacaoComercial)}>{messages[lang].ApprovedOrRefused[this.statusConciliacao(result.statusConciliacaoComercial)]}</Badge>
										</Col>
									</Col>
									<Col xs={6} className="pr-3 pl-4">
										<Col className="rounded-top bg-color-primary py-2">
											<span className="text-2">{messages[lang].statusRFM}</span>
										</Col>
										<Col className="rounded-bottom py-2 border-primary">
											<Badge pill variant={this.statusConciliacao(result.statusConciliacaoFiscal)}>{messages[lang].conciliationStatus[this.statusConciliacao(result.statusConciliacaoFiscal)]}</Badge>
										</Col>
									</Col>
								</Row>
							</Container>

							<Container className="my-4">
								<Row className="conciliations-result">
									<Col xs={6} className="pr-3 pl-4">
										<Col className="rounded-top bg-color-primary py-2">
											<span className="text-2">{messages[lang].reasonForDisapproval}</span>
										</Col>
										<Col className="rounded-bottom py-2 border-primary">
										<div className="align-justify">
											<span className="text-2">{result.motivoReprovacao === '' ? ' - ' : result.motivoReprovacao}</span>
										</div>
										</Col>
										<Col>
											<br/>
											<ButtonStandard
												id="view_disapproval_history_button"
												text={messages[this.props.lang].viewDisapprovalHistory}
												textClass="text-2"
												disabled={false}
												isLoading={this.state.buttonLoading}
												className="btn-sm btn-outline-primary btn-standard px-2 mr-2"
												onClick={() => this.setModalShowHistory(true)}
											/>
										</Col>
									</Col>

									<Col xs={6} className="pr-3 pl-4">
										<Col className="rounded-top bg-color-primary py-2">
											<span className="text-2">{messages[lang].conciliationHistoryListPage.observacao}</span>
										</Col>
										<Col className="rounded-bottom py-2 border-primary">
										<div className="align-justify">
											<span className="text-2">{result.observacao ? result.observacao : ''}</span>
										</div>
										</Col>
										<Col>
											<br/>
											<ButtonStandard
												id="view_disapproval_history_button"
												text={result.observacao ? messages[this.props.lang].conciliationHistoryListPage.editObservacao : messages[this.props.lang].conciliationHistoryListPage.addObservacao}
												textClass="text-2"
												disabled={false}
												isLoading={this.state.buttonLoading}
												className="btn-sm btn-outline-primary btn-standard px-2 mr-2"
												onClick={() => this.setModalObservacao(true)}
											/>
										</Col>
									</Col>
								</Row>
							</Container>
						</Container>
				}
				{ !isLoading && isEmpty &&
					<div>
						<p className="text-3 text-color-primary my-0 pt-1">
							{messages[lang].noData}
						</p>
					</div>
				}
				{ !isEmpty &&
					<FooterActions 
						ButtonGroupLeft={this.buttonGroupLeft()}
						ButtonGroupRight={this.buttonGroupRight()} />
				}
				
				{
					<ConciliationHistoryResultModal
						show={this.state.modalShowHistory}
						onHide={() => { this.setModalShowHistory(false) }}
						history={conciliationHistory}/>
				}

				{
					<Modal
						show={modalConfirmCancel}
						onHide={() => { this.setModalConfirmCancel(false) }}
						aria-labelledby="contained-modal-title-vcenter"
						className="conciliation-history-result-modal"
						centered
					>	
						<Modal.Header className="text-left" closeButton>
							<Modal.Title className="w-100 font-weight-bold">
								{messages[this.props.lang].cancelConciliation}
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Container style={{textAlign: 'center'}} className="px-0 mb-0 pb-0">
								<Form>
									<Form.Group as={Col} xs={12} className="mt-1">
									<Form.Label className="text-5">{messages[this.props.lang].cancelConciliationPrompt}</Form.Label>
									<Form.Control
										required
										as="textarea"
										value={this.state.motivoCancelamento}
										className="text-2 border-radius-full"
										type="text"
										maxLength={255}
										rows={2}
										onChange={event => this.setState(
                                            { motivoCancelamento: event.target.value },
                                        )}
										/>
									</Form.Group>
								</Form>

								<ButtonStandard
										id="cancel_conciliationf"										
										text={messages[this.props.lang].cancelConciliation}
										textClass="text-4"									
										isLoading={this.state.buttonLoading}
										disabled={this.state.buttonLoading || this.state.motivoCancelamento === '' || !this.state.motivoCancelamento.replace(/\s/g, '').length}
										className="btn-primary btn-sm btn-standard px-2 mr-2"
										onClick={() => this.cancelarConciliacao()}
								/>

							
							</Container>
			
						</Modal.Body>
					</Modal>
				}

				{
					<Modal
						show={modalObservacao}
						onHide={() => { this.setModalObservacao(false) }}
						aria-labelledby="contained-modal-title-vcenter"
						className="conciliation-history-result-modal"
						centered
					>	
						<Modal.Header className="text-left" closeButton>
							<Modal.Title className="w-100 font-weight-bold">
								{messages[this.props.lang].conciliationHistoryListPage.observacao}
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Container style={{textAlign: 'center'}} className="px-0 mb-0 pb-0">
								<Form>
									<Form.Group as={Col} xs={12} className="mt-1">
									<Form.Label className="text-5">{messages[this.props.lang].conciliationHistoryListPage.observacaoPrompt}</Form.Label>
									<Form.Control
										required
										as="textarea"
										defaultValue={result.observacao || ''}
										className="text-2 border-radius-full"
										type="text"
										maxLength={255}
										rows={2}
										onChange={event => this.setState(
                                            { textoModalObservacao: event.target.value },
                                        )}
										/>
									</Form.Group>
								</Form>

								<ButtonStandard
										id="cancel_conciliationf"										
										text={messages[this.props.lang].save}
										textClass="text-4"									
										isLoading={this.state.buttonLoading}
										disabled={false}
										className="btn-primary btn-sm btn-standard px-2 mr-2"
										onClick={() => this.alterarObservacao()}
								/>

							
							</Container>
			
						</Modal.Body>
					</Modal>
				}

				{
					<Modal
						show={modalMotivoReprovacao.show}
						onHide={() => {
							this.props.dispatchModalMotivoReprovacao(
								false,
								'',
								''
							);
						}}
						aria-labelledby="contained-modal-title-vcenter"
						className="conciliation-history-result-modal"
						centered
					>	
						<Modal.Header className="text-left" closeButton>
							<Modal.Title className="w-100 font-weight-bold">
								{`${messages[lang].motivoReprovacaoItem} ${modalMotivoReprovacao.item}`}
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Container style={{textAlign: 'center'}} className="px-0 mb-0 pb-0">
								{modalMotivoReprovacao.message}
							</Container>
			
						</Modal.Body>
					</Modal>
				}
			</div>
		)
	}
}

const mapStateToProps = state => ({
	lang: state.language.name,
	orderList: state.orderList,
	conciliationResult: state.conciliationResult,
	tradeConciliation: state.reconcile.tradeConciliation,
	taxConciliation: state.reconcile.taxConciliation,
	fileStep: state.reconcile.fileStep,
	conciliationSeal: state.conciliationSeal,
	permissions: state.authorization.permissions,
	resultStep: state.reconcile.resultStep,
	provider: state.provider
});

const mapDispatchToProps = dispatch => {
	return {
		dispatchConciliationResult: (order) =>
			dispatch({
				type: "GET_CONCILIATION_RESULT",
				payload: order
			}),
		dispatchConciliationSeal: (conciliationId) =>
			dispatch({
				type: "GET_CONCILIATION_SEAL",
				conciliationId: conciliationId
			}),
		dispatchCancelConciliation: (order, motivoCancelamento) =>
			dispatch({
				type: "CANCEL_CONCILIATION",
				payload: {
					order,
					motivoCancelamento
				}				
			}),
		dispatchAlterarObservacao: (order, observacao) =>
			dispatch({
				type: "SALVAR_OBSERVACAO",
				payload: {
					order,
					observacao
				}				
			}),
		dispatchShowCancelModal: (show) =>
			dispatch({
				type: "SET_MODAL_CONFIRM_CANCEL",
				payload: {
					show
				}				
			}),
		dispatchModalObservacao: (show) =>
			dispatch({
				type: "SET_MODAL_OBSERVACAO",
				payload: {
					show
				}				
		}),
		dispatchModalMotivoReprovacao: (show, item, message) =>
		dispatch({
			type: "SHOW_MOTIVO_REPROVACAO_MODAL",
			show: show,
			item: item,
			message: message
		}),
		dispatchSetPageReload: (reload) =>
			dispatch({
				type: "SET_RELOAD_CONCILIATION_RESULT_PAGE",
				payload: {
					reload
				}				
			}),
		dispatchConciliationConditional: (conciliationId, order) =>
			dispatch({
				type: "GET_CONCILIATION_CONDITIONAL",
				payload: {
					conciliationId,
					order
				}
			}),
        dispatchCheckConciliationStatus: (conciliationId, order) =>
            dispatch({
                type: "GET_CONCILIATION_STATUS",
                payload: {
                    conciliationId,
                    order
                }
            }),
		dispatchDownloadInvoice: (conciliationId, order) =>
			dispatch({
				type: "GET_INVOICE",
				payload: {
					conciliationId,
					order
				}
			}),
		dispatchResetConciliation: (order) =>
			dispatch({
				type: "RESET_RECONCILE",
			}),
		dispatchConciliationHistory: (order) =>
			dispatch({
				type: "GET_CONCILIATION_HISTORY",
				payload: order
			}),
		dispatchHideToast: () =>
			dispatch({
				type: "HIDE_TOAST"
			}),
	};
};


export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(ConciliationResultPage)
);